import { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import "../../main.scss"
import "./User.scss"
import { authAPI } from "../api/authApi"
import { useAuth } from "../auth/AuthContext"

const LoginVerify = () => {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { refreshUser } = useAuth()
  const returnPathParam = searchParams.get('returnPath')
  useEffect(() => {
    const verifyToken = async () => {
      const token = searchParams.get('token')

      if (!token) {
        setError('Invalid login link')
        setLoading(false)
        return
      }

      try {
        console.log('🔐 LoginVerify: Verifying token...')
        await authAPI.loginVerify(token)
        console.log('✅ LoginVerify: Token verified successfully')
        
        await refreshUser()

        if (returnPathParam && returnPathParam.startsWith('/')) {
          navigate(returnPathParam)
          return
        }
        navigate("/")
      } catch (err: any) {
        console.error('❌ LoginVerify: Verification failed:', err)
        setError(err.message || 'Login verification failed')
        setLoading(false)
      }
    }

    verifyToken()
  }, [searchParams, navigate, refreshUser])

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "300px",
            padding: "20px",
            boxSizing: "border-box",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          }}
          className="panel"
        >
          <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Verifying login...</h1>
          <p style={{ textAlign: "center" }}>Please wait while we verify your login link.</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100vw",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "300px",
            padding: "20px",
            boxSizing: "border-box",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          }}
          className="panel"
        >
          <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Verification Failed</h1>
          <p style={{ color: "red", textAlign: "center", marginBottom: "20px" }}>{error}</p>
          <button className="buttonSubmit mt-4" onClick={() => navigate("/login")}>
            Return to Login
          </button>
        </div>
      </div>
    )
  }

  return null
}

export default LoginVerify


